var React = require('react');

function NpLongVertical (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38.0006 0.0152105C58.987 0.0143608 76.0006 17.0266 76.0013 38.0131L76.0095 268.556C76.0102 289.542 58.9981 306.556 38.0118 306.557C17.0253 306.557 0.0117386 289.545 0.0110006 268.559L0.00285713 38.0158C0.00211153 17.0295 17.0142 0.0160603 38.0006 0.0152105Z"}));
}

NpLongVertical.defaultProps = {"width":"77","height":"307","viewBox":"0 0 77 307"};

module.exports = NpLongVertical;

NpLongVertical.default = NpLongVertical;
